<!-- 
AddToFamilyNewModal.vue
功能：加入現有家戶視窗
作者：i9400538 陳博承
完成：2021-07-28
-->
<template>
  <div class="modal fade" :class="{'is-open': open}">
    <div class="modal-dialog w-900">
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="text-green m-0 mt-1">加入現有家戶</h3>
        </div>
        <!-- 挑選家戶區塊-->
        <div class="modal-body" v-show="!isNext">
          <div class="row mt-2 mb-4">
            <div class="col-12">
              <span class="cust-name">請選擇欲加入的家戶</span>
              <br />
              <br />
              <form class="form">
                <div class="input-group input-lg">
                  <div class="input">
                    <input
                      type="text"
                      id="keyword-Family"
                      class="form-control"
                      v-model="keyword"
                      placeholder="輸入姓名、身分證進行搜尋..."
                      alt="ch"
                      maxlength="100"
                      @keydown.enter="doSearch()"
                    />
                    <span v-show="keyword!==''" id="searchclear" @click="doClean()">清除</span>
                  </div>
                  <button
                    class="btn btn-primary btn-icon"
                    type="button"
                    @click.stop.prevent="doSearch()"
                  >
                    <i class="icon-search i-24"></i>
                  </button>
                </div>
              </form>
            </div>
          </div>

          <div class="row row-tables newTable">
            <div class="col-table pr-0">
              <table id="family-list" class="table datatable table-striped area-list-datatable">
                <thead>
                  <tr>
                    <th width="120px">#</th>
                    <th
                      id="col_name"
                      :class="'sorting ' + (order.fieldName == 'subject' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                      @click="processList('name')"
                    >戶長姓名</th>
                    <th
                      id="col_csidno"
                      :class="'sorting ' + (order.fieldName == 'csidno' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                      @click="processList('id')"
                    >身分證</th>
                    <th
                      id="col_birthday"
                      :class="'sorting ' + (order.fieldName == 'birthday' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                      @click="processList('birthday')"
                    >生日</th>
                    <th
                      id="col_age"
                      :class="'sorting ' + (order.fieldName == 'age' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                      @click="processList('age')"
                      ref="lastCol"
                    >年齡</th>
                  </tr>
                </thead>
                <tbody v-if="familyList.length">
                  <tr v-for="(item, i) in familyList" :key="`familyList-${item.familymemberid}`">
                    <td width="120px">
                      <div class="radio radio-inline mr-0">
                        <input
                          type="radio"
                          :id="`familyList-radio-${item.familymemberid}`"
                          :value="item"
                          v-model="selectedFamily"
                        />
                        <label :for="`familyList-radio-${item.familymemberid}`">{{i + 1}}</label>
                      </div>
                      <span class="info text-center">
                        <level :lv="Number(item.vip_lvl)" />
                        <avatar :gender="Number(item.sex)" :size="20" />
                      </span>
                    </td>
                    <td>
                      <Tooltip
                        :position="i < 3 ?'bottom':'top'"
                        :name="item.name"
                        :id="item.showid"
                        :birthday="item.birthday"
                      >{{item.name | getMaskName}}</Tooltip>
                    </td>
                    <td>{{item.showid | getMaskID}}</td>
                    <td>{{item.birthday | dateFormat | getMaskBirthday}}</td>
                    <td :width="iPadWidth">{{item.age}}</td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td colspan="4" class="empty">
                      <h3 class="text-center py-5">查無資料，請確認您輸入之資料是否正確</h3>
                    </td>
                    <td v-show="false"></td>
                    <td v-show="false"></td>
                    <td v-show="false"></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!-- 按鈕區塊-->
          <div class="row">
            <div class="col-12">
              <div class="actions text-right mt-4">
                <a @click="$emit('close')" class="btn btn-default">取消</a>
                <a @click="doNext" class="btn btn-primary" :disabled="selectedFamily.length">下一步</a>
              </div>
            </div>
          </div>
        </div>
        <!-- 設定家戶成員區塊-->
        <div class="modal-body" v-show="isNext">
          <span class="cust-name">請確認成員身分與基本資料</span>
          <br />
          <h5>本次將加入的成員</h5>
          <div class="row row-tables">
            <div class="col-table pr-0">
              <table id="add-list" class="table datatable table-striped area-list-datatable">
                <thead>
                  <tr>
                    <th width="143">
                      身分
                      <span class="text-red padding-25">*必填</span>
                    </th>
                    <th>姓名</th>
                    <th>性別</th>
                    <th>生日</th>
                    <th>年齡</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td width="143">
                      <select
                        :id="`family-role-${colKey}`"
                        :data-vv-name="`family-role-${colKey}`"
                        v-validate="'required'"
                        data-vv-as="身分"
                        class="form-control form-control-inline"
                        :class="{ 'is-invalid': errors.has(`family-role-${colKey}`) }"
                        v-model="role"
                      >
                        <option value>請選擇</option>
                        <option
                          v-for="(opt, i) in roleOpt"
                          :key="`family-role-${i}`"
                          :value="opt.val"
                        >{{opt.text}}</option>
                      </select>
                    </td>
                    <td>{{newCust.name}}</td>
                    <td>{{newCust.sexText}}</td>
                    <td>{{newCust.birthday}}</td>
                    <td>{{newCust.age}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <h5>此家戶原本的成員</h5>
          <!-- 家戶原本的成員區塊-->
          <div
            class="row row-tables"
            :class="familyMemberList.length > 5  ? 'newTable' : ''"
          >
            <div class="col-table pr-0">
              <table id="add-list" class="table datatable table-striped area-list-datatable">
                <thead>
                  <tr>
                    <th>身分</th>
                    <th>姓名</th>
                    <th>性別</th>
                    <th>生日</th>
                    <th>年齡</th>
                  </tr>
                </thead>
                <tbody v-if="familyMemberList.length">
                  <tr
                    v-for="(item, i) in familyMemberList"
                    :key="`familyMemberList-${item.familymemberid}`"
                  >
                    <td>{{item.familyrlText}}</td>
                    <td>
                      <Tooltip
                        :position="i < 3 ?'bottom':'top'"
                        :name="item.name"
                        :birthday="item.birthday"
                      >{{item.name | getMaskName}}</Tooltip>
                    </td>
                    <td>{{item.sexText}}</td>
                    <td>{{item.birthday | dateFormat | getMaskBirthday}}</td>
                    <td :width="iPadWidthCol">{{item.age}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!-- 按鈕區塊-->
          <div class="row">
            <div class="col-12">
              <div class="actions text-right mt-4">
                <a @click="doPrevious" class="btn btn-default">上一步</a>
                <a @click="doAdd" class="btn btn-primary">加入</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 打開遮罩 -->
    <mxMask :open="mxMaskOpen" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { commonMixin } from "@/mixins/common";
//component
import Level from "@/components/Level";
import Avatar from "@/components/Avatar";
import Tooltip from "@/desktop/components/ToolTip";
import mxMask from "@/desktop/components/mxMask";
//service
import { getAllFamily } from "@/service";
//parameter
const is_iPad = navigator.userAgent.match(/iPad/i) != null; // 確認裝置是否為 iPad
export default {
  name: "AddToFamilyNewModal",
  mixins: [commonMixin],
  components: { Level, Avatar, Tooltip, mxMask },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    allFamily: {
      type: Array
    },
    newCust: {
      type: Object,
      default: () => {
        return {};
      }
    },
    type: {
      type: String,
      default: ""
    }
  },
  watch: {
    open: function(val) {
      if (val) {
        this.initColWidth();
        this.familyList = [...this.allFamily];
        this.keyword = "";
        this.selectedFamily = [];
        this.isNext = false;
        this.role = "";
      }
    },
    familyList: function() {
      this.registerHanlink();
    },
    familyMemberList: function() {
      this.registerHanlink();
    },
    keyword: "changeKeyword"
  },
  computed: {
    ...mapGetters(["UserInfo"])
  },
  data() {
    return {
      keyword: "",
      familyList: [], //已選擇區塊顯示用
      selectedFamily: [], //已選擇家戶
      order: {
        fieldName: "name",
        asc: true
      },
      iPadWidth: 150,
      iPadWidthCol: 143,
      mxMaskOpen: false,
      isNext: false,
      colKey: "1",
      role: "",
      roleOpt: [
        { text: "配偶", val: 1 },
        { text: "子女", val: 2 },
        { text: "父母", val: 3 },
        { text: "孫子女", val: 5 },
        { text: "其他", val: 4 }
      ],
      familyMemberList: [] //已選擇家戶底下成員
    };
  },
  methods: {
    //欄位排序
    processList(fieldName) {
      let order = this.order;
      if (order.fieldName == fieldName) {
        order.asc = !order.asc;
      } else {
        order.fieldName = fieldName;
        order.asc = true;
      }

      //data排序
      let sortOrder = -1;
      if (order.asc) {
        sortOrder = 1;
      }

      switch (fieldName) {
        case "birthday":
          setTimeout(() => {
            this.familyList.sort(this.dateCompareFun(sortOrder, fieldName));
            this.registerHanlink(); // 難字顯示
          }, 20);
          break;
        default:
          setTimeout(() => {
            this.familyList.sort(this.sortCompareFun(sortOrder, fieldName));
            this.registerHanlink(); // 難字顯示
          }, 20);
      }
    },
    sortCompareFun(sortOrder, property) {
      return function(a, b) {
        let result =
          a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
        return result * sortOrder;
      };
    },
    //日期排序
    dateCompareFun(sortOrder, property) {
      return function(a, b) {
        let date_a = new Date(
          a[property] ? a[property] : "1880-01-01"
        ).getTime();
        let date_b = new Date(
          b[property] ? b[property] : "1880-01-01"
        ).getTime();
        let result = date_a < date_b ? -1 : 1;
        return result * sortOrder;
      };
    },
    //清除關鍵字
    doClean() {
      this.keyword = "";
    },
    //關鍵字搜尋
    doSearch() {
      if (this.keyword.trim() != "") {
        let s = this.keyword.toUpperCase();
        this.familyList = this.allFamily.filter(item => {
          let t = item.name.toUpperCase();
          return t.includes(s) || this.ToDBC(t).includes(this.ToDBC(s));
        });
        if (!this.familyList.length) {
          this.familyList = this.allFamily.filter(item => {
            let t = item.id.toUpperCase();
            return t.includes(s) || this.ToDBC(t).includes(this.ToDBC(s));
          });
        }
      } else {
        this.familyList = [...this.allFamily];
      }
    },
    //半形轉化為全形
    ToDBC(str) {
      let result = "";
      let len = str.length;
      for (let i = 0; i < len; i++) {
        let cCode = str.charCodeAt(i);
        //全形與半形相差（除空格外）：65248(十進位制)
        cCode = cCode >= 0x0021 && cCode <= 0x007e ? cCode + 65248 : cCode;
        //處理空格
        cCode = cCode == 0x0020 ? 0x03000 : cCode;
        result += String.fromCharCode(cCode);
      }
      return result;
    },
    //上一步
    doPrevious() {
      this.isNext = false;
    },
    //下一步
    doNext() {
      if (!this.selectedFamily.id) {
        return;
      }
      this.mxMaskOpen = true;
      getAllFamily(this.UserInfo.id, this.selectedFamily.id).then(result => {
        this.mxMaskOpen = false;
        this.isNext = true;
        if (result.header && result.header.status == "200") {
          this.familyMemberList = result.data.map(item => {
            return {
              age: item.age,
              agidno: item.agidno,
              birthday: item.birthday,
              csidno: item.csidno,
              familyid: item.familyid,
              familymemberid: item.familymemberid,
              familyorder: item.familyorder,
              familyrl: item.familyrl,
              familyrlText: this.getRoleName()[item.familyrl],
              memochk: item.memochk,
              name: item.name,
              sex: item.sex,
              sexText: item.sex == "1" ? "男" : "女"
            };
          });
        } else {
          this.setToastMsg("取得家戶資料失敗: ", result.header.message);
        }
      });
    },
    //加入
    doAdd() {
      this.$validator.validateAll().then(el => {
        if (!el) {
          this.setToastMsg("尚有必填欄位待確認");
          return;
        }
        this.$validator.reset();
        this.newCust.familyName = this.selectedFamily.name; //戶長姓名
        this.newCust.newFamilyId = this.selectedFamily.id;
        this.newCust.familyrl = this.role;
        this.$emit("submit", this.newCust);
      });
    },
    changeKeyword() {
      //檢查輸入欄位
      this.keyword = this.keyword.replace(
        /[<>!#$^&,"'?%*:;+{}[\]|~`=\\\s]/g,
        ""
      );
      if (this.stringBytes(this.keyword, false, 100) > 100) {
        this.keyword = this.keyword.substring(
          0,
          this.stringBytes(this.keyword, true, 100)
        );
      }

      if (this.keyword === "") {
        this.familyList = [...this.allFamily];
      }
    },
    //欄位寬度初始化
    initColWidth() {
      if (!is_iPad) {
        this.iPadWidth = 135;
        this.iPadWidthCol = 128;
      }
    },
    //取得角色名稱
    getRoleName() {
      return {
        0: "戶長",
        1: "配偶",
        2: "子女",
        3: "父母",
        4: "其他",
        5: "孫子女"
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.newTable thead tr,
.newTable tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
}

.newTable tbody {
  display: block;
  height: 350px;
  overflow-y: scroll;
  border: 0 !important;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    width: 17px;
    border: 0;
    box-shadow: none;
  }

  &::-webkit-scrollbar-track {
    box-shadow: none;
    border-radius: 0px;
    border: 0;
    background-color: #f5f5f5;
  }

  &::-webkit-scrollbar-thumb {
    width: 10px;
    border-radius: 20px;
    background-color: #555;
  }
}

.row.row-tables {
  width: 100%;
  margin-left: 0;
  margin-right: 0;
  display: table;
  > * {
    position: relative;
    display: table-cell;
  }
  .col-table {
    width: 100% !important;
  }
  .icon-forward {
    visibility: hidden;
  }
}

#searchclear {
  position: absolute;
  right: 25px;
  top: 14px;
  bottom: 0;
  margin-right: 58px;
  font-size: 16px;
  font-weight: bold;
  text-decoration: underline;
  cursor: pointer;
  color: green;
}

.w-900 {
  width: 900px;
}

.cust-name {
  font-size: 18px;
  font-weight: 600;
}

.h-140 {
  height: 140px;
}

.padding-25 {
  padding-left: 25px;
}
</style>